import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';
import { useOfficialAccount } from '@/hooks';
import cx from 'clsx';
import { OfficialAccountAvatar } from '@/components';
import styles from './index.module.scss';
import { getOfficialPath, openNewWindow } from '@/utils';

export const OfficialTag = ({
  officialId,
  className,
}: {
  officialId: string;
  className?: string;
}) => {
  const { t } = useTranslation();

  const { officialAccountDetail, isLoading } = useOfficialAccount(officialId);

  const handleClick = useCallback(() => {
    if (officialAccountDetail) {
      openNewWindow(getOfficialPath(officialAccountDetail), '_blank');
    }
  }, [officialAccountDetail]);

  if (isLoading) {
    return null;
  }
  return (
    <div className={cx(styles.container, className)} onClick={handleClick}>
      {t('OfficialTag.107cxxo')}
      <OfficialAccountAvatar
        size={14}
        className={styles.avatar}
        data={officialAccountDetail}
        logoVisible={false}
      />
      <div className={styles.name}>{officialAccountDetail?.name}</div>
    </div>
  );
};
